import { radiusTokens, shadowTokens, spacingTokens, typeStyles } from "@union/tokens";
import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// tailwind-merge only knows Tailwind's default scales. Without our token names it can't tell
// that px-space-5 and px-0, or h-tap-min and h-9, conflict, so an override passed in className
// would silently lose. Teach it our scales, and that type-* utilities are one group (a later
// type style replaces an earlier one).
const merge = extendTailwindMerge<"type-style">({
  extend: {
    theme: {
      spacing: [...spacingTokens],
      radius: [...radiusTokens],
      shadow: [...shadowTokens],
      container: [...spacingTokens],
    },
    classGroups: { "type-style": [{ type: [...typeStyles] }] },
  },
});

/** Joins class names, and lets later Tailwind classes win over earlier ones. */
export function cn(...inputs: ClassValue[]): string {
  return merge(clsx(inputs));
}
